.switchInputGroup {
  --ixf-switch-input-group-border-radius: var(--ixf-border-radius-2);
  --ixf-switch-input-group-border-width: 1px;
  --ixf-switch-input-group-border-color: var(--ixf-color-separator);

  .container {
    .inputContainer {
      display: flex;
      flex-direction: column;
      align-items: stretch;
      justify-content: center;
      border-left: var(--ixf-switch-input-group-border-width) solid
        var(--ixf-switch-input-group-border-color);
      border-right: var(--ixf-switch-input-group-border-width) solid
        var(--ixf-switch-input-group-border-color);
      border-bottom: var(--ixf-switch-input-group-border-width) solid
        var(--ixf-switch-input-group-border-color);
      padding: var(--ixf-space-2) var(--ixf-space-3) var(--ixf-space-2)
        var(--ixf-space-4);

      &.switch {
        min-height: var(--ixf-input-height);
      }

      > * {
        --ixf-switch-padding: 0 !important;

        label {
          flex: 1 1 auto;
          cursor: pointer;
        }
      }

      &.first {
        border-top: var(--ixf-switch-input-group-border-width) solid
          var(--ixf-switch-input-group-border-color);
        border-radius: var(--ixf-switch-input-group-border-radius)
          var(--ixf-switch-input-group-border-radius) 0 0;
      }

      &.last {
        border-radius: 0 0 var(--ixf-switch-input-group-border-radius)
          var(--ixf-switch-input-group-border-radius);

        &.hasHint,
        &.hasAggregateError {
          border-radius: 0;
        }
      }

      &.only {
        border-top: var(--ixf-switch-input-group-border-width) solid
          var(--ixf-switch-input-group-border-color);
        border-radius: var(--ixf-switch-input-group-border-radius);

        &.hasHint,
        &.hasAggregateError {
          border-radius: var(--ixf-switch-input-group-border-radius)
            var(--ixf-switch-input-group-border-radius) 0 0;
        }
      }
    }

    .hint,
    .error {
      box-shadow: 0 -1px 0 0 var(--ixf-color-background);
      --ixf-form-hint-border-radius: 0 0
        var(--ixf-switch-input-group-border-radius)
        var(--ixf-switch-input-group-border-radius);
    }
  }
}
